import QuestionValueRatio from "./QuestionValueRatio";

export default class QuestionValueRatio3 extends QuestionValueRatio {
    constructor(numerator, denominator, denominator2) {
        super(numerator, denominator);

        this._value /= denominator2;
        this._denominator2 = denominator2;
    }

    toString() {
        return this._numerator + ":" + this._denominator + ":" + this._denominator2;
    }
}